<template>
    <div class="body">
        <transition appear>
          <div v-if="!reportData" class="zhezhao">
              <div class="image" style="width: 100%; height: 13%">
                <img src="@/assets/logo2.png" style="width: 217px; height: 77px; margin-left: 7px"/>
              </div>

              <div class="right" style="width: 100%; height: 87%">
                <p class="font1" style="font-size: 86px; margin-top: 20vh;color: #176ed2;"> 2024富学宝典</p>
                <p class="font1" style=" color: #99345d;font-size: 71px;margin-top: 20px;color: #176ed2;"> 五月学习报告 </p>
                <p class="font1" style="font-size: 41px;margin-top: 27px;color: #2b92c9;"> 坚持学习的人永葆青春 </p>
               
                <div v-show="!Loading" class="input-container" style="margin-top: 4vh">
                  <input v-model="jobNo" type="text" id="input" required="" />
                  <label for="input" class="label">请输入工号</label>
                  <div class="underline"></div>
                </div>
                <div v-show="!Loading" style="display: flex; justify-content: center;margin-top:40px;">
                  <button class="button" @click="inputJobNo()">NEXT</button>
                </div>
                <!-- <LoadingAuguest v-show="Loading" style="margin-top: 30vh" /> -->
              </div>
          </div>
        </transition>
        <main v-if="reportData && reportData.studate != 0" id="main" ref="scrollDiv" class="view">
          <section id="section01" class="section">
              <!-- 有学习天数，有学分 -->
              <div v-if="reportData.studate > 0 && reportData.creditvalue > 0" style="display: flex; flex-wrap: wrap">
                <div class="left" style="width: 100%; margin-top: 10vh">
                  <p class="font1" style="font-size: 30px; margin-top: 21px;">Hi～<span class="font2" style="font-size: 36px;">{{ reportData.stuname }}</span>，我们又见面啦</p>
                  <p class="font1" style="font-size: 30px; margin-top: 15px;"><span class="font2" style="font-size: 36px;">2024</span>年<span class="font2" style="font-size: 36px;">5</span>月</p>

                  <p class="font1" style="font-size: 30px;margin-top: 15px;">你已经学习了<span class="font2" style="font-size: 32px;">{{ reportData.studate }}</span>天</p>
                  <p class="font1" style="font-size: 30px;margin-top: 15px;">累计学习了<span class="font2" style="font-size: 32px;">{{ reportData.playtime }}</span >小时</p>

                  <p class="font1" style="font-size: 30px;margin-top: 15px;">学习了<span class="font2" style="font-size: 32px;">{{ reportData.creditvalue }}</span >门课程</p>
                  <p class="font1" style="font-size: 36px;text-align: center;margin-top: 45px;">完成了<span class="font2" style="font-size: 32px;">{{ reportData.creditvalue }}</span >门课程</p>

                  <p class="font1" style="font-size: 30px;margin-top: 15px;">累计考试<span class="font2" style="font-size: 32px;">{{ reportData.creditvalue }}</span >次</p>
                  <p class="font1" style="font-size: 36px;text-align: center;margin-top: 45px;">获得学分<span class="font2" style="font-size: 32px;">{{ reportData.creditvalue }}</span >分</p>
                </div>
              </div>

              <!-- 有学习天数，没有学分 -->
              <div v-if="reportData.studate > 0 && !reportData.creditvalue" style="display: flex; flex-wrap: wrap">
                <div class="left" style="width: 100%; margin-top: 10vh">
                  <p class="font1" style="font-size: 30px; margin-top: 21px;">Hi～<span class="font2" style="font-size: 36px;">{{ reportData.stuname }}</span>，我们又见面啦</p>
                  <p class="font1" style="font-size: 30px; margin-top: 15px;"><span class="font2" style="font-size: 36px;">2024</span>年<span class="font2" style="font-size: 36px;">5</span>月</p>

                  <p class="font1" style="font-size: 30px;margin-top: 15px;">你在富学宝典平台上的总学习天数达到了<span class="font2" style="font-size: 32px;">{{ reportData.studate }}</span >天</p>
                  <p class="font1" style="font-size: 30px;margin-top: 15px;">但是还没有获得学分，请继续加油！</p>
                  <p class="font2" style="font-size: 36px;text-align: center;margin-top: 45px;">{{ reportData.textLab.text }}</p>
                </div>
              </div>

               <!-- 没有学习天数，没有学分 -->
              <div v-if="!reportData.studate && !reportData.creditvalue" style="display: flex; flex-wrap: wrap">
                <div class="left" style="width: 100%; margin-top: 20vh">
                  <p class="font1" style="font-size: 30px; margin-top: 21px;">Hi～<span class="font2" style="font-size: 36px;">{{ reportData.stuname }}</span>，我们又见面啦</p>
                  <p class="font1" style="font-size: 30px; margin-top: 15px;"><span class="font2" style="font-size: 36px;">2024</span>年<span class="font2" style="font-size: 36px;">5</span>月</p>

                  <p class="font1" style="font-size: 30px;margin-top: 15px;">你还没有在富学宝典上学习，请继续加油！</p>
                  <p class="font2" style="font-size: 36px;text-align: center;margin-top: 45px;">{{ reportData.textLab.text }}</p>
                </div>
              </div>
          </section>


          <section id="section02" class="section">
              <div class="page2" style="display: flex; flex-wrap: wrap">
                <div class="right" style="width: 100%; margin-top: 10vh">
                  <p class="font2" style="font-size: 30px; margin-top: 21px;text-align: center;">勤学如春起之苗</p>
                  <p class="font2" style="font-size: 30px; margin-top: 21px;text-align: center;">不见其增，日有所长。</p>

                  <p  style="text-align: center;font-weight: 700;color: black; font-size: 30px;margin-top: 21px;">2024年富学宝典上热门课程推荐：</p>
                  <div v-for="(item,index) in mergeBook.slice(0,3)" :key="index" style="width: 100%;margin: 0 auto;text-align: center;margin-top: 2vh;font-size: 30px;color: #000;">
                     <p @click="redirectToBook(index)" class="font1" style="margin-top: 1vh;">{{item.Name}}&nbsp;&nbsp;<i class="fa fa-arrow-right fa-lg" ></i></p>
                  </div>

                  <p  v-if="uncompletedLink !==null"  style="text-align: center;font-weight: 700;color: #000; font-size: 30px;margin-top: 21px;">以下课程已学习过半，您离完成目标只差一步之遥：</p>
                  <div  v-for="(item,index) in mergeBook.slice(3)" :key="index+3" style="width: 100%;margin: 0 auto;text-align: center;margin-top: 2vh;font-size: 30px;color: #000;">
                     <p @click="redirectToBook(index+3)" class="font1" style="margin-top: 1vh;">{{item.Name}}&nbsp;&nbsp;<i class="fa fa-arrow-right fa-lg" ></i></p>
                  </div>
                </div>
              </div>
          </section>

          <section id="section03" class="section">
              <div style="display: flex; flex-wrap: wrap">
                <div class="right" style="width: 100%; margin-top: 10vh">
                  <p class="font2" style="font-size: 30px; margin-top: 21px;text-align: center;">勤耕岁月学无涯，</p>
                  <p class="font2" style="font-size: 30px; margin-top: 21px;text-align: center;">积学成才道路赊。</p>
                  <!-- <div>
                    <p class="font1" style="margin: 0 auto; font-size: 30px;color: #000;text-align: center;margin-top: 3vh;">2024年必修课程：</p>
                    <ul style="margin: 0 auto; font-size: 30px;color: #000;;text-align: center;margin-top: 3vh;">
                      <li>{{ coc[0].Name }}&nbsp;&nbsp;<span class="font3" v-if="coc[0].iscompleted===true">已完成</span><span class="font3" v-else>未完成</span></li>
                      <li>{{ coc[1].Name }}&nbsp;&nbsp;<span class="font3" v-if="coc[1].iscompleted===true">已完成</span><span class="font3" v-else>未完成</span></li>
                    </ul>
                    <p style="width: 100%;margin: 0 auto;font-size: 15px;color: #000;margin-top: 3vh;text-align: center;">**具体可登录富学宝典查看:【首页】>【个人设置】>【学习任务】**</p>
                  </div> -->
                  <div>
                    <p class="font1" style="margin: 0 auto; font-size: 30px;color: #000;text-align: center;margin-top: 3vh;">EHS+ESG 5月主题课程推荐：</p>
                    <ul style="margin: 0 auto; font-size: 30px;color: #000;;text-align: center;margin-top: 3vh;">
                      <ul v-for="(item,index) in themeLink" :key="index" ref="">
                          <a :href="item.link" style="text-decoration: none;color: #000;"><li style="padding: 0;margin-top: 0;">{{ item.Name }}</li></a>
                      </ul>
                    </ul>
                  </div>
                </div>
              </div>
          </section>

          <section id="section04" class="section">
              <div class="page4"  style="display: flex; flex-wrap: wrap">
                <div class="title"><p class="font1" style="font-size: 60px;">好书推荐</p></div>
                    <div class="left" style="margin-top: 40px;width: 80%;margin: 0 auto;">
                        <div class="detail">
                            <p style="text-align: center;font-size: 30px;color: #000;">《框架思维》</p>
                            <p class="font2" style="font-size: 18px;text-align: center;">维克托·迈尔-舍恩伯格</p>
                        </div>
                        <div class="bookDetail" style="font-size: 17px;padding: 20px;color: #000;">
                            <span style="font-size: 20px;">
                              框架思维是一本探讨如何通过构建和应用思维框架来提升问题解决能力和决策质量的书籍。<br><br>  
                              在这个信息爆炸的时代，掌握框架思维，意味着能够更有效地筛选信息，深入分析问题的本质。本书不仅解释了框架思维的理论基础，还提供了丰富的实用工具和方法，帮助读者在实际工作和生活中应用这种思维模式。从实践挑战到思维习惯的培养，作者以清晰的逻辑和生动的案例，引导我们如何一步步搭建自己的认知框架，有效应对未来的挑战和机遇。<br><br>  
                              无论你是领导者、企业家还是个人发展者，这本书都将是你理解和应用框架思维的宝贵资源。<br><br>  
                            </span>
                        </div>
                    </div>
                    <div class="right" style="margin-top: 40px;width: 80%;margin: 0 auto;">
                        <div class="detail">
                          <p style="text-align: center;font-size: 30px;color: #000;">《战略思维》</p>
                          <p class="font2" style="font-size: 18px;text-align: center;">[英]弗雷德·佩拉德（Fred Pelard）</p>
                        
                        </div>
                        <div class="bookDetail" style="font-size: 17px;padding: 20px;">
                          <span style="font-size: 20px;text-align: justify;color:#000;">
                            本书深入浅出地探讨了战略思维不仅是高管的专利，而是每个人都可以掌握的关键技能。<br><br>
                            作者强调，战略思维的核心在于一种面向解决问题的心态，而非仅仅依赖经验或视野的广阔。<br><br>
                            书中提供了一系列实用的战略思考模式和工具，帮助读者在面对战略问题时减少不确定性，即使在数据不足的情况下也能制定出可靠的策略。<br><br>
                            无论你是企业高管、普通员工还是自由职业者，这本书都将为你的职业生涯和个人发展提供极大的帮助，让你的战略思维能力得到显著提升，并在实际应用中越来越熟练。<br><br>
                          </span>
                        </div>
                    </div>         
              </div>
          </section>

          <section id="section05" class="section">
              <div class="page5" style="position: relative;top: 10vh;">
                    <div style="margin: 0 auto;margin-top: 10vh">
                        <p class="font1" style="font-size: 30px; text-align: center;">你希望在富学宝典平台上遇见哪些好课程呢?</p>
                        <p class="font1"  style="font-size: 28px;text-align: center;margin-top: 2vh;">请写下你的学习清单吧！</p>
                        <form id="form" class="topBefore">
                            <textarea id="message" v-model="comment" type="text" placeholder="MESSAGE"></textarea>
                            <input id="submit"  @click="submit" type="button" value="OK!" />
                        </form>
                    </div>
                    <div style="padding-top: 70px;margin: 0 auto;">
                        <p style="font-size: 48px;text-align: center;color: #000;">THANK YOU!</p>
                        <p class="font1" style="font-size: 48px;text-align: center;">一旦决心学习，谁也拦不住你</p>
                    </div>
              </div>
          </section>
        </main>
    </div>
</template>

<script>
import Loading from './Loading.vue'
import viewApi from "@/api/view";
import dataApi from "@/api/data";
import { getArray } from "../../utils/encourage";
export default {
    data(){
      return{
        viewId: "",
        Loading:false,
        reportData:'',
        jobNo:'',
        comment: "",
        source: "",

        recommendBook:'',
        uncompletedLink:'',
        mergeBook:'',
        coc:'',
        themeLink:''
      }
    },
    created(){
      document.title = "五月学习报告";
      /* 相信数据begin */
      var test = window.location.href
      let arr = test.split("?code=")
      this.code = arr[1]
      if (this.code) {
        viewApi.getJobNoByBelieve(this.code).then((res) => {
          if(res.data.code === 200) {
            this.jobNo = res.data.data.jobNo
            this.source = "相信"
            if (this.jobNo) {
              this.Loading = true;
              this.getData()
            }
          }
        })
      }
      /* 相信数据end */
    },
    methods:{
      submit() {
      if (!this.comment) {
        this.$message({
          message: "请说说您的学习计划",
          type: "warning",
          center: true,
        });
      } else if (this.comment) {
        const view = {
          comment: this.comment,
          studyList: this.studyList,
        };
        view["id"] = this.viewId;
        // console.log(view);
        viewApi.update(view).then((res) => {
          if (res) {
            this.$message({
              message: "提交成功，感谢您的留言。",
              type: "success",
              center: true,
            });
          }
        });
      }
      },
      inputJobNo() {
            if (this.Loading === true) {
              return;
            }
            if (this.jobNo) {
              this.Loading = true;
              this.getData();
            } else {
              this.$message({
                message: "请输入工号",
                type: "warning",
                center: true,
              });
            }
      },
      getData() {
            dataApi.getDataFor24May(this.jobNo).then((res) => {
              this.reportData = res.data.data.data;
              // console.log(res.data.data.data);

              this.recommendBook=JSON.parse(this.reportData.topRecommendLink)
              this.uncompletedLink=JSON.parse(this.reportData.uncompletedLink)
              this.mergeBook=this.recommendBook.concat(this.uncompletedLink)
              // this.coc=JSON.parse(this.reportData.coc)
              this.themeLink=JSON.parse(this.reportData.themeLink)
              if (this.reportData) {
                this.sendViewRecords();
                // this.Loading = false;
                this.reportData.textLab = getArray(this.reportData.textLab);
              } else if (!this.reportData) {
                this.$message({
                  message: "抱歉，暂时找不到您的学习报告！",
                  type: "warning",
                  center: true,
                });
                this.Loading = false;
              }
            });
      },
      sendViewRecords() {
          if (this.jobNo) {
            let viewData = {
              jobNo: this.jobNo,
              device: "PC",
              type: 18,
              browser: this.browser,
            };
            if (this.source) {
              viewData["source"] = this.source;
            }
            viewApi.view(viewData).then((res) => {
              this.viewId = res.data.data.data.id;
            });
          } else {
            return;
          }
      },
      redirectToBook(id){
        const book=this.mergeBook[id]
        const view={
            clickCourseName:book.Name,
            clickCourseLink:book.link
        }
        view["id"] = this.viewId;
        viewApi.update(view).then((res) => {
          if (res.data.code===200) {
            window.location.href = view.clickCourseLink;
          }
        });
      }
    },
    mounted(){
     
    }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
/* 字体样式 */
.font1{
  color:rgb(36, 35, 35); 
  font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  font-weight: 700; 
  text-align: center;
}
.font2{
  color: #176ed2; 
  font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  font-weight: 700; 
}

.font3{
  color: #70b787; 
  font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  text-align: center;
}
/* 第一页 */
.body {
  width: 100vw;
  height: 100vh;
  position: absolute;
  left: 0;
  top: 0;
  overflow: hidden;
}

.zhezhao {
  width: 100vw;
  height: 100vh;
  /* background-image: linear-gradient(170deg, #b55d7f , #953b5d); */
  background:url("../../assets/24May/pcbg1.jpg")  no-repeat;
  background-size: 100% 100%,cover;
  position: absolute;
  display: flex;
  flex-wrap: wrap;
}
.input-container {
  position: relative;
  margin: 50px auto;
  width: 400px;
}

.input-container input[type="text"] {
  font-size: 20px;
  width: 100%;
  border: none;
  border-bottom: 2px solid #000;
  padding: 5px 0;
  background-color: transparent;
  outline: none;
  color: #67b4dd;
}

.input-container .label {
  position: absolute;
  top: 0;
  left: 0;
  color: #000;
  transition: all 0.3s ease;
  pointer-events: none;
}

.input-container input[type="text"]:focus ~ .label,
.input-container input[type="text"]:valid ~ .label {
  top: -20px;
  font-size: 16px;
  color: #2b92c9;
}

.input-container .underline {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 2px;
  width: 100%;
  background-color: #67b4dd;
  transform: scaleX(0);
  transition: all 0.3s ease;
}

.input-container input[type="text"]:focus ~ .underline,
.input-container input[type="text"]:valid ~ .underline {
  transform: scaleX(1);
}
.button {
  --bg: #2b92c9;
  --text-color: #67b4dd;
  position: relative;
  width: 150px;
  height: 40px;
  border: none;
  background: var(--bg);
  color: var(--text-color);
  padding: 1em;
  font-weight: bold;
  text-transform: uppercase;
  transition: 0.2s;
  border-radius: 5px;
  opacity: 0.8;
  letter-spacing: 1px;
  box-shadow: #67b4dd 0px 7px 2px, #000 0px 8px 5px;
}

.button:hover {
  opacity: 1;
}

.button:active {
  top: 4px;
  box-shadow: #67b4dd 0px 3px 2px, #000 0px 3px 5px;
}

/* 第二页 */
.view {
  width: 100%;
  height: 100%;
  background:url("../../assets/24May/pcbg2.jpg")  no-repeat;
  background-size: 100% 100%,cover;
  /* background-image: linear-gradient(170deg, #7a94ac , #a2bed8); */
}
main {
  scroll-snap-type: y mandatory;
  scroll-padding: 80px;
  overflow: scroll;
  height: 100vh;
}
section {
  width: 100vw;
  height: 100vh;
  scroll-snap-align: start;
}
#section01,#section02,#section03,#section04{
  position: relative;
}
ul{
    list-style-type: none;
    padding: 0;
    color: #fff;
    text-align: center;
}
li {
    align-items: center;
    margin-bottom: 8px; 
}

/* li::before {
    content: '\2022'; 
    color: #fff;
    font-size: 1.5em;
    margin-right: 3px; 
    margin: 0 auto;
} */

/*书籍推荐页 */
.title {
  font-size: 50px;
  width: 100%;
  margin-bottom: 30px;
  margin-top: 30px;
}


/* 最后的输入框 */
#form {
  position: relative;
  width: 40vw;
  padding-top: 50px;
  margin: 0 auto;
}

input {
  font-family: "Lato", sans-serif;
  font-size: 0.875em;
  width: 570px;
  height: 50px;
  padding: 0px 15px 0px 15px;
  background: transparent;
  outline: none;
  color: #000;
  border: solid 1px #fff;
  border-bottom: none;
  transition: all 0.3s ease-in-out;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
}

input:hover {
  background: #fff;
  color: #000;
}

textarea {
  width: 40vw;
  max-width: 40vw;
  height: 20vh;
  max-height: 20vh;
  padding: 0;
  background: transparent;
  outline: none;
  color: #000;
  font-family: "Lato", sans-serif;
  font-size: 0.875em;
  border: solid 1px #36854f;
  transition: all 0.3s ease-in-out;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
}

/* textarea:hover {
  background: #e89fbb;
  color: #fff;
} */

#submit {
  width:  40vw;
  padding: 0;
  margin: -5px 0px 0px 0px;
  font-family: "Lato", sans-serif;
  font-size: 0.875em;
  color: #000;
  outline: none;
  cursor: pointer;
  border: solid 1px #36854f;
  border-top: none;
}

#submit:hover {
  color: #b3aca7;
}
/* 

*/
</style>